import React from "react"

const CHANGE_EVENT = "appsignal:sidebar-submenu-change"
export const SidebarSubmenuPathContext = React.createContext<string[]>([])

const subscribe = (onChange: () => void) => {
  window.addEventListener(CHANGE_EVENT, onChange)
  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange)
  }
}

// Both sidebar presentations can be mounted at once. Read the same preference
// and notify both, so hidden inline menus cannot retain stale expansion state.
export const useSidebarSubmenuState = (title: string, scope?: string[]) => {
  const parentPath = React.useContext(SidebarSubmenuPathContext)
  const path = scope ?? parentPath
  // Preserve saved preferences while separating groups such as Errors > Views
  // and Logging > Views, which used to share a title-only storage key.
  const legacyKey = `side-menu-sub-${title}`
  const key = path.length > 0 ? `side-menu-sub-${JSON.stringify([...path, title])}` : legacyKey
  const isOpen = React.useSyncExternalStore(
    subscribe,
    () => Boolean(JSON.parse(localStorage.getItem(key) ?? localStorage.getItem(legacyKey) ?? "false")),
  )
  const setIsOpen = React.useCallback((open: boolean) => {
    localStorage.setItem(key, String(open))
    window.dispatchEvent(new Event(CHANGE_EVENT))
  }, [key])

  return [isOpen, setIsOpen] as const
}
